// extracted by mini-css-extract-plugin
export default {"sbmain":"Sidebar_sbmain__M32ke"};